Vue.directive('focus', {
    bind: function () {
        Vue.nextTick(function () {
            this.el.focus();
        }.bind(this));
    }
});

// Directives
Vue.directive('mask-money', {
    params: ['options'],

    bind: function () {
        $(this.el).maskMoney(this.params.options);
    },
});

// Directives
Vue.directive('datepicker', {
    twoWay: true,

    params: ['options', 'date'],

    paramWatchers: {
        date: function (val, oldVal) {
            var $dateRangePicker = $(this.el).data('daterangepicker');

            if (! val) {
                $dateRangePicker.minDate = null;
                return;
            }

            var date = moment(val, 'DD/MM/YYYY'),
                currentDate = moment(this.el.value, 'DD/MM/YYYY');

            $dateRangePicker.minDate = date;

            if (currentDate.diff(date, 'days') < 0) {
                $dateRangePicker.setStartDate(val);
            }
        }
    },

    bind: function () {
        var self = this;

        if (self.params.options.disabled) return;

        $(self.el).daterangepicker(self.params.options);
    },
});

// Sortable
Vue.directive('sortable', {
    twoWay: true,
    priority: 1000,

    params: ['options'],

    bind: function () {
        var self = this;

        this.params.options.onUpdate = function () {
            self.update(this.toArray());
        },

        this.sortable = Sortable.create(this.el, this.params.options);
    },

    update: function (val) {
        if (typeof val === 'undefined') {
            return;
        }

        this.vm.$emit(this.params.options.eventName, val);
    },

    unbind: function () {
        this.sortable.destroy();
    }
});
